import { push } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import classes from './NoticeList.module.scss'
import Hero from '../../components/notice/Hero'
import SearchField from '../../components/notice/SearchField'
import { useEffect, useState } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebase'
import ArticleCard from '../../components/notice/ArticleCard'
import { PERMISSIONS } from '../../constants/permissions'
import { getUserInfo, getUserRole } from '../../reducks/users/selectors'
import classNames from 'classnames'
import { SelectBox } from '../../components/UIkit'
import {
  categoriesAll,
  isOpenStatuses,
  publishStatusesAll,
} from '../../constants/notice'
import WithIconButton from '../../components/UIkit/WithIconButton'
import FiberNewIcon from '@mui/icons-material/FiberNew'
import SelectBoxForNotice from '../../components/UIkit/SelectBoxForNotice'

function getCategoryId(query) {
  const decodedQuery = decodeURIComponent(query)
  console.log('decodedQuery', decodedQuery)
  const category = /^\?category=/.test(decodedQuery)
    ? decodedQuery.split('?category=')[1]
    : ''

  return category
}

const NoticeList = () => {
  const userRole = useSelector(getUserRole)
  const userInfo = useSelector(getUserInfo)
  const categoryId = getCategoryId(
    useSelector((state) => state.router.location.search)
  )

  const isAdministrator =
    userRole === PERMISSIONS.ADMINISTRATOR ||
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER
  const dispatch = useDispatch()
  const [keyword, setKeyword] = useState('')
  const [articles, setArticles] = useState([])
  const [filteredArticles, setFilteredArticles] = useState([])
  const [adminMode, setAdminMode] = useState(isAdministrator)
  const [category, setCategory] = useState(categoryId || 'すべて')
  const [openStatus, setOpenStatus] = useState('すべて')
  const [publishStatus, setPublishStatus] = useState('公開')
  const [manualTitle, setManualTitle] = useState('') //マニュアルにフィルタがかかったときに使用するタイトル
  // ...既存の状態とフック
  const [currentPage, setCurrentPage] = useState(1)
  const articlesPerPage = 10

  // 総ページ数を計算
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage)

  // 表示する記事を計算
  const indexOfLastArticle = currentPage * articlesPerPage
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage
  const displayedArticles = filteredArticles.slice(
    indexOfFirstArticle,
    indexOfLastArticle
  )
  useEffect(() => {
    setAdminMode(isAdministrator)
    if (isAdministrator) {
      setPublishStatus('すべて')
    }
  }, [isAdministrator])
  // ページネーションの関数
  const paginate = (pageNumber) => setCurrentPage(pageNumber)
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }
  const firstPage = () => setCurrentPage(1)
  const lastPage = () => setCurrentPage(totalPages)

  useEffect(() => {
    setCurrentPage(1)
  }, [keyword, category, publishStatus])
  useEffect(() => {
    const articleRef = collection(db, 'articles')
    const unsubscribe = onSnapshot(articleRef, (snapshot) => {
      const latestArticles = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => {
          // createdDay の降順で比較
          if (a.createdDay > b.createdDay) return -1
          if (a.createdDay < b.createdDay) return 1

          // createdDay が同じ場合、updatedAt の降順で比較
          return b.updatedAt.toDate() - a.updatedAt.toDate()
        })

      setArticles(latestArticles)
    })

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe()
  }, [])

  useEffect(() => {
    const filtered = articles.filter((article) => {
      const matchesKeyword =
        keyword === '' ||
        article.title.toLowerCase().includes(keyword.toLowerCase()) ||
        article.content.toLowerCase().includes(keyword.toLowerCase())

      const matchesCategory =
        category === 'すべて' || article.category === category
      const matchesOpenStatus =
        openStatus === 'すべて' ||
        (openStatus === '既読' &&
          article.targetUsers.some(
            (user) => user.email === userInfo.email && user.isOpened
          )) ||
        (openStatus === '未読' &&
          (article.targetUsers.some(
            (user) => user.email === userInfo.email && !user.isOpened
          ) ||
            !article.targetUsers.some((user) => user.email === userInfo.email)))
      const matchesPublishStatus =
        publishStatus === 'すべて' || article.publishStatus === publishStatus

      const isVisible = adminMode || article.publishStatus === '公開'

      return (
        matchesKeyword &&
        matchesCategory &&
        matchesPublishStatus &&
        isVisible &&
        matchesOpenStatus
      )
    })

    setFilteredArticles(filtered)
  }, [articles, keyword, category, publishStatus, adminMode, openStatus])
  const getPageNumbers = () => {
    const pageNumbers = []

    // 開始ページと終了ページを計算
    let startPage = Math.max(currentPage - 2, 1)
    let endPage = Math.min(currentPage + 2, totalPages)

    // ページ数が5未満の場合、表示するページ数を調整
    if (endPage - startPage < 4) {
      if (startPage === 1) {
        endPage = Math.min(5, totalPages)
      } else if (endPage === totalPages) {
        startPage = Math.max(totalPages - 4, 1)
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i)
    }

    return pageNumbers
  }
  useEffect(() => {
    if (category === 'マニュアル') {
      setManualTitle('マニュアル一覧')
    } else {
      setManualTitle('')
    }
  }, [category])
  return (
    <div className={classes.root}>
      <Hero title={manualTitle ? manualTitle : 'お知らせ一覧'} />
      <div className={classes.main}>
        <SearchField keyword={keyword} setKeyword={setKeyword} />

        <div className={classes.controls}>
          {isAdministrator && (
            <div className={classes.buttons}>
              <div
                onClick={() => setAdminMode(!adminMode)}
                className={classNames(
                  classes.button,
                  adminMode ? classes.admin : undefined
                )}
              >
                {adminMode ? '管理者表示' : '一般表示'}
              </div>
              <WithIconButton
                label="投稿"
                fontSize={14}
                width={100}
                height={32}
                bottom={0}
                color="blue"
                icon={<FiberNewIcon />} // アイコンをpropsで渡す
                onClick={() => dispatch(push(`/notice/new`))}
              />
            </div>
          )}
          {/*カテゴリ */}
          <div className={classes.select}>
            <SelectBoxForNotice
              label={'カテゴリ'}
              options={categoriesAll}
              required={true}
              select={(e) => setCategory(e)}
              value={category}
              width="120px"
              height="50px"
              color="#4dd0e1"
              fontSize="14px"
              labelFontSize="14px"
            />
            {/*既読・未読 */}
            <SelectBoxForNotice
              label={'状態'}
              options={isOpenStatuses}
              required={true}
              select={(e) => setOpenStatus(e)}
              value={openStatus}
              width="120px"
              height="50px"
              color="#4dd0e1"
              fontSize="14px"
              labelFontSize="14px"
            />
            {isAdministrator && (
              <SelectBoxForNotice
                label={'公開区分'}
                options={publishStatusesAll}
                required={true}
                select={(e) => setPublishStatus(e)}
                value={publishStatus}
                width="120px"
                height="50px"
                color="#4dd0e1"
                fontSize="14px"
                labelFontSize="14px"
              />
            )}
          </div>
        </div>
        <div className={classes.articles}>
          {displayedArticles.map((article) => (
            <ArticleCard
              article={article}
              key={article.id}
              isAdministrator={adminMode}
            />
          ))}
        </div>
      </div>
      <div className={classes.pagination}>
        <button
          className={classes.buttonLast}
          onClick={firstPage}
          disabled={currentPage === 1}
        >
          最初
        </button>
        <button
          className={classes.buttonNext}
          onClick={prevPage}
          disabled={currentPage === 1}
        >
          {'<'}
        </button>

        {getPageNumbers().map((number) => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={number === currentPage ? classes.activePage : null}
          >
            {number}
          </button>
        ))}

        <button
          className={classes.buttonNext}
          onClick={nextPage}
          disabled={currentPage === totalPages}
        >
          {'>'}
        </button>
        <button
          onClick={lastPage}
          disabled={currentPage === totalPages}
          className={classes.buttonLast}
        >
          最後
        </button>
      </div>
    </div>
  )
}

export default NoticeList
